<template>
  <v-card
    @click="() => typeof widget.data.link!=='undefined' ? move(widget.data.link) : null"
    v-if="widget.type==='multipleKpiTile'"
    :style="widget.data.color==='primary' ? 'background-color: #0575e6; background-image: linear-gradient(to right, #0575e6, #021b79)' : widget.data.color==='warning' ? 'background-color: #fdc830; background-image: linear-gradient(to right, #fdc830, #f37335)' : widget.data.color==='success' ? 'background: linear-gradient(to right, #34e89e, #0f3443)' : widget.data.color==='error' ? 'background-color: #eb5757; background-image: linear-gradient(to right, #eb5757, #000000)' : 'background:' + widget.data.color "
    dark
  >
    <v-card-text>
     <span style="font-size: 20px ; float: left;width: 100%"> {{ widget.data.title }} <span style="float: left"> {{ widget.data.model }} {{ widget.data.prefix }}</span></span>
      <v-row>
        <v-col>
          <v-simple-table dense style="background-color: transparent ; width: 100%">
            <template v-slot:default>
              <tbody style="background-color: transparent">
              <tr
                v-for="item in widget.data.firstColumnItems"
                :key="item.name"
                style="color: white"
              >
                <td style="color: white">{{ item.title }}</td>
                <td style="color: white">{{ item.value }} {{ item.prefix }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col>
          <v-simple-table dense style="background-color: transparent ; width: 100%">
            <template v-slot:default>
              <tbody style="background-color: transparent">
              <tr
                v-for="item in widget.data.secoundColumnItems"
                :key="item.name"
                style="color: white"
              >
                <td style="color: white">{{ item.title }}</td>
                <td style="color: white">{{ item.value }} {{ item.prefix }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import router from "@/router";
import baseConfig from '@/../baseConfig'
import axios from "@axios";

export default {
  name: "multiple-kpi-tile",
  props: {
    widget: Object
  },
  data(){
    return {
      do:1
    }
  },
  mounted() {
    this.refresh()
  },
  destroyed(){
    this.do=0
    console.log("leave")
  },
  methods: {
    async refresh(){
      setTimeout(this.refresh,parseInt(this.widget.data.time))
      if (this.do){
        let resultAction = this.widget.data.action.includes("http");
        let whereIsAction = ""
        if (resultAction) {
          whereIsAction = this.widget.data.action
        } else {
          whereIsAction = baseConfig.baseUrl + this.widget.data.action
        }

        await axios.get(whereIsAction).then(async r => {
          this.widget.data.model = r.data.model
          this.widget.data.firstColumnItems.map(c=>{
            c.value = r.data.items[c.name]
          })
          this.widget.data.secoundColumnItems.map(c=>{
            c.value = r.data.items[c.name]
          })
        })
      }
    },
    move(link) {
      let result = link.includes("http");
      if (result) {
        window.location.href = link
      } else {
        router.push(link)
      }
    }
  }
}
</script>

<style scoped>

</style>
